import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { Info } from "lucide-react";

export const PendingDataView = () => {
  return (
    <Flex
      marginTop="16px"
      width="100%"
      flex="1"
      minHeight="420px"
      borderRadius="16px"
      backgroundColor={AppColors.BACKGROUND_SECONDARY}
      alignItems="center"
      justifyContent="center"
      flexDir="column"
      gap="12px"
    >
      <Flex borderRadius="full" alignItems="center" justifyContent="center">
        <Info size={60} color={AppColors.GRAY_TEXT} />
      </Flex>
      <Text fontWeight={500} color={AppColors.GRAY_TEXT} textAlign="center">
        Seleccione el tipo de insumo y camión para visualizar las fechas
      </Text>
    </Flex>
  );
};
